import { generateRandomKey } from './StorageService.parts';

interface Storage {
  get(key: string): unknown | null;

  set(key: string, value: unknown): void;

  remove(key: string): void;

  clear(): void;
}

class MemoStorage implements Storage {
  private storage = new Map<string, string>();

  get(key: string) {
    return this.storage.get(key);
  }

  set(key: string, value: string) {
    this.storage.set(key, value);
  }

  remove(key: string) {
    this.storage.delete(key);
  }

  clear() {
    this.storage.clear();
  }
}

class LocalStorage implements Storage {
  public static canUse() {
    const TEST_KEY = generateRandomKey();

    try {
      localStorage.setItem(TEST_KEY, 'test');
      localStorage.removeItem(TEST_KEY);
      return true;
    } catch (error) {
      return false;
    }
  }

  set(key: string, value: string) {
    localStorage.setItem(key, value);
  }

  get(key: string) {
    return localStorage.getItem(key);
  }

  remove(key: string): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }
}

function generateLocalStorage() {
  if (LocalStorage.canUse()) {
    return new LocalStorage();
  }
  return new MemoStorage();
}

export const safeLocalStorage = generateLocalStorage();
